import { Form, Input } from "semantic-ui-react";
import { SharedAddressFieldProps } from "./AddressFormField";
import classNames from "classnames";
import { useId } from "react-aria";

interface AttnFormFieldProps extends SharedAddressFieldProps {}

export function AttnFormField({
  disabled,
  error,
  labelClassName,
  label = "Attn",
  subLabel,
  value,
  transform,
  handleChange,
}: AttnFormFieldProps) {
  const id = useId();
  return (
    <Form.Field className='tw-w-auto' disabled={disabled} error={!!error}>
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      {subLabel && (
        <div
          className={classNames("sub-label", {
            "tw-text-[#b2b2b2]": disabled,
          })}
        >
          {subLabel}
        </div>
      )}
      <Input
        id={id}
        type='text'
        disabled={disabled}
        value={transform.input(value)?.attn ?? ""}
        onChange={(_, { value }) => handleChange({ attn: value })}
      />
    </Form.Field>
  );
}
